import { render } from "./PInput.vue?vue&type=template&id=c3bb43c0&scoped=true&ts=true"
import script from "./PInput.vue?vue&type=script&lang=ts"
export * from "./PInput.vue?vue&type=script&lang=ts"

import "./PInput.vue?vue&type=style&index=0&id=c3bb43c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3bb43c0"]])

export default __exports__